import React from "react";
import { ExternalLink, Briefcase, GraduationCap, ShoppingBag, Users, Info } from "lucide-react";

const LINKS = [
  { i: <Briefcase size={22}/>, t: "Pula Jobs", d: "Find verified builders, artisans and property professionals across Southern Africa.",
    href: "https://pula.co", cta: "Open Pula Jobs" },
  { i: <GraduationCap size={22}/>, t: "Pula Learn", d: "Free short courses on property, building basics and financial literacy.",
    href: "https://pula.co", cta: "Open Pula Learn" },
  { i: <ShoppingBag size={22}/>, t: "Pula Market", d: "Sell goods and services to fund your MAVULA deposit — community-first commerce.",
    href: "https://pula.co", cta: "Open Pula Market" },
  { i: <Users size={22}/>, t: "Pula Community", d: "Connect with neighbours, share progress and build local support circles.",
    href: "https://pula.co", cta: "Open Pula Community" },
];

export default function PulaPage() {
  return (
    <main className="max-w-6xl mx-auto px-4 md:px-8 py-14 md:py-20" data-testid="pula-page">
      <div className="mv-eyebrow"><span style={{ color: "var(--mv-gold)" }}>§ The Pula Ecosystem</span></div>
      <h1 className="font-display text-4xl md:text-5xl mv-green-text mt-3">
        MAVULA is stronger — <span className="font-accent italic" style={{ color: "var(--mv-gold)" }}>together with Pula.</span>
      </h1>
      <p className="mt-4 max-w-2xl text-[15px]" style={{ color: "var(--mv-muted)" }}>
        Property is only part of building a life. MAVULA cross-links to the Pula community platform for skills,
        markets, learning and neighbours.
      </p>

      <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-5" data-testid="pula-links">
        {LINKS.map((l) => (
          <a
            key={l.t}
            href={l.href} target="_blank" rel="noopener"
            className="mv-card p-6 group hover:-translate-y-1 transition-transform"
            data-testid={`pula-link-${l.t.toLowerCase().replaceAll(" ", "-")}`}
          >
            <div className="flex items-start justify-between gap-3">
              <div className="w-11 h-11 rounded-2xl flex items-center justify-center mv-green-text" style={{ background: "rgba(212,175,55,0.16)" }}>{l.i}</div>
              <ExternalLink size={18} className="opacity-40 group-hover:opacity-100 mv-green-text"/>
            </div>
            <div className="mt-4 font-display text-xl mv-green-text">{l.t}</div>
            <p className="mt-1 text-[14px]" style={{ color: "var(--mv-muted)" }}>{l.d}</p>
            <div className="mt-4 text-[12.5px] font-semibold" style={{ color: "var(--mv-gold)" }}>{l.cta} →</div>
          </a>
        ))}
      </div>

      <div className="mt-10 mv-card p-6 flex items-start gap-3" style={{ background: "linear-gradient(180deg, #fff, rgba(212,175,55,0.06))" }}>
        <Info className="mv-green-text shrink-0" size={22}/>
        <div>
          <div className="font-semibold mv-green-text">Coming soon: one unified account.</div>
          <div className="text-[14px] mt-1" style={{ color: "var(--mv-muted)" }}>
            Your MAVULA progress will appear inside your main Pula profile — no extra logins. We are working with the
            Pula team to launch single sign-on. Until then, these cross-links open Pula in a new tab.
          </div>
        </div>
      </div>
    </main>
  );
}
